import styles from './DataGrid.module.css';

interface GenericOverlayProps {
	overlayText: string;
}

export function GenericOverlay(props: GenericOverlayProps) {
	return (
		<div className={styles['no-rows-overlay-container']}>
			<span>{props.overlayText || 'No Rows'}</span>
		</div>
	);
}
